import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/project/job/${number | ':jobId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/project/job/:jobId`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/project/job/${jobId}`;
